import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { auth, storage } from '@/lib/firebase'

export async function uploadCommunityPostCarouselImage(uid: string, file: File): Promise<string> {
  const firebaseUser = auth.currentUser
  if (!firebaseUser || firebaseUser.uid !== uid) {
    throw new Error('You must be signed in as this user to upload board images.')
  }

  const maxSize = 20 * 1024 * 1024
  if (file.size > maxSize) {
    throw new Error('Images must be smaller than 20MB for board posts.')
  }

  const fileExtensionLower = file.name.toLowerCase().slice(file.name.lastIndexOf('.'))
  const fallbackExtension = fileExtensionLower && fileExtensionLower.length <= 10 ? fileExtensionLower : '.jpg'
  const timestamp = Date.now()
  const objectPath = `community-post-images/${uid}/${timestamp}-${Math.random().toString(16).slice(2)}${fallbackExtension}`
  const storageReference = ref(storage, objectPath)

  let mimeType = file.type || 'image/jpeg'
  if (!file.type || file.type === '') {
    if (fallbackExtension === '.png') mimeType = 'image/png'
    else if (fallbackExtension === '.webp') mimeType = 'image/webp'
    else if (fallbackExtension === '.gif') mimeType = 'image/gif'
    else mimeType = 'image/jpeg'
  }

  await uploadBytes(storageReference, file, {
    contentType: mimeType,
    cacheControl: 'public,max-age=31536000',
  })

  return getDownloadURL(storageReference)
}
